export default __webpack_public_path__ + "static/media/key-visual.44822541.png";